import React, { useState } from 'react';

import { Modal } from '@wds/modal';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';

import PropTypes from 'prop-types';
import STRINGS from '../../constants';

import PasswordField from '../components/PasswordField';

const DisconnectAccountModal = (props) => {
	const {
		open,
		setOpen,
		handleOnSuccess,
	} = props;
	const [newPassword, setNewPassword] = useState('');
	const [isPasswordValid, setIsPasswordValid] = useState(false);

	const handleOnClose = () => {
		setOpen(false);
	};

	const handleDisconnect = () => {
		handleOnSuccess(newPassword, STRINGS.toast.accountDisconnected);
		handleOnClose();
	};

	const handleStateChange = (e) => {
		setNewPassword(e.target.value);
	};

	return (
		<Box id='sma-disconnect-account-modal'>
			<Modal
				size='md'
				show={open}
				onClose={handleOnClose}
				aria-labelledby='disconnect-modal-header'
				aria-describedby='disconnect-modal-description'
			>
				<Modal.Header
					id='disconnect-modal-header'
					header={STRINGS.accountSettingsPage.modals.disconnectAccountModal.areYouSureTitle}
				/>
				<Modal.Body>
					<Box mt={5}>
						<Box mb={5} id='disconnect-modal-description'>
							<Typography variant='bodySm' lineHeight={1.5}>
								{STRINGS.accountSettingsPage.modals.disconnectAccountModal.upperText}
							</Typography>
							<Box style={{ height: '20px' }} />
							<Typography variant='bodySm' lineHeight={1.5}>
								{STRINGS.accountSettingsPage.modals.disconnectAccountModal.lowerText}
							</Typography>
							<Box style={{ height: '20px' }} />
							<PasswordField
								id='new_password'
								onChange={handleStateChange}
								placeholder={STRINGS.newPasswordPlaceholder}
								usePopout={false}
								setIsPasswordValid={setIsPasswordValid}
								aria-invalid={!isPasswordValid}
								aria-describedby='password-requirements'
							/>
						</Box>
					</Box>
				</Modal.Body>
				<Modal.Footer align='right'>
					<Button
						onClick={handleDisconnect}
						id='sma-modal-disconnect-button'
						color='warning'
						disabled={!isPasswordValid}
						aria-label={STRINGS.disconnectBtn}
					>
						{STRINGS.disconnectBtn}
					</Button>
				</Modal.Footer>
			</Modal>
		</Box>
	);
};

DisconnectAccountModal.propTypes = {
	open: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired,
	handleOnSuccess: PropTypes.func.isRequired,
};

export default DisconnectAccountModal;
